import * as React from "react"
import styled from "styled-components"
import { createMarkup, Icon, Rte } from ".."
import { colors, scale, breakpoint } from "../../styles"
import { Flex } from "../Flex"
import { Text } from "../Text"

interface AlertBoxProps {
	type: string
	header: string
	body: string
	isGlobal: boolean
	expanded: boolean
	pageAlerts: Alert[]
	index: number
}

declare type Alert = {
	type: string
	header: string
	body: string
	isGlobal: boolean
}

export const ALERT_HEIGHT = 8

interface AlertBoxStyledProps {
	firstChild: boolean
	i: number
}

const AlertBoxStyled = styled.div<AlertBoxStyledProps>`
	display: flex;
	max-width: 100%;
	min-width: calc(50% - 12px);
	width: 100%;
	border-bottom: 1px solid ${colors.coral66};
	border-top: ${(props) =>
		props.i === 0 ? `1px solid ${colors.coral66}` : "none"};

	@media screen and (min-width: ${scale.px(96)}) {
		max-width: ${scale.px(69)};
		border-top: ${(props) =>
		props.firstChild || props.i === 1
			? `1px solid ${colors.coral66}`
			: "none"};
	}
`

const AlertBox: React.FC<AlertBoxProps> = (props) => {
	const firstChild = props.pageAlerts.length > 1 && props.index === 0

	return (
		<AlertBoxStyled firstChild={firstChild} i={props.index}>
			<Flex minh={6} w={6}>
				<Icon
					icon={props.type === "Alert" ? "warning-triangle" : "info-circle"}
					size={4.5}
					ml={-0.5}
					my={props.expanded ? "6px" : "auto"}
				/>
			</Flex>
			<Flex
				flexDirection="column"
				w={1}
				maxw="calc(100% - 48px)"
				pr={{ _: props.pageAlerts.length <= 1 ? 3 : 0, m: 0 }}
			>
				<Flex flexDirection="column" my={props.expanded ? 0 : "auto"}>
					<Text
						variant="paragraph-14"
						fontWeight="bold"
						truncate={{
							_: props.expanded ? "none" : "twoLine",
							m: props.expanded ? "none" : "oneLine",
						}}
						my={1}
						mr={{ _: firstChild ? 4 : 0, m: 0 }}
					>
						{props.header}
					</Text>
				</Flex>
				<Flex w={1} display={props.expanded ? "flex" : "none"}>
					<Rte>
						<Text as="div" variant="paragraph-16">
							<div dangerouslySetInnerHTML={createMarkup(props.body)}></div>
						</Text>
					</Rte>
				</Flex>
			</Flex>
		</AlertBoxStyled>
	)
}

export { AlertBox }
